export default "__VITE_ASSET__697437da__"